module.exports = __webpack_public_path__ + "img/activities-11.535df6b9.jpg";